/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.5 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18 8A6 6 0 116 8a6 6 0 0112 0zM4.75 22c0-1.368.737-2.663 2.043-3.643C8.1 17.378 9.937 16.75 12 16.75c2.063 0 3.901.628 5.207 1.607 1.305.98 2.043 2.275 2.043 3.643a.75.75 0 001.5 0c0-1.946-1.053-3.65-2.643-4.843-1.59-1.192-3.751-1.907-6.107-1.907-2.356 0-4.517.715-6.107 1.907C4.303 18.35 3.25 20.054 3.25 22a.75.75 0 001.5 0z" _fill="#000"/>'
  }
})
